import axios from 'axios';
import { API_URL } from '../config';
import api from './api';

const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  return {
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  };
};

// Check for existing contact with same email and message
export const checkExistingContact = async (email, message) => {
  const response = await api.post('/api/contact/check', { email, message });
  return response.data;
};

// Submit contact form
export const submitContactForm = async (formData) => {
  const response = await api.post('/api/contact', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

// Admin endpoints
export const getAllContacts = async (params) => {
  const response = await axios.get(`${API_URL}/api/contact`, { 
    ...getAuthHeaders(),
    params 
  });
  return response.data;
};

export const getContactById = async (id) => {
  const response = await axios.get(`${API_URL}/api/contact/${id}`, getAuthHeaders());
  return response.data;
};

export const updateContactStatus = async (id, status) => {
  const response = await axios.patch(
    `${API_URL}/api/contact/${id}/status`, 
    { status },
    getAuthHeaders()
  );
  return response.data;
};

export const addContactNote = async (id, content) => {
  const response = await axios.post(
    `${API_URL}/api/contact/${id}/notes`, 
    { content },
    getAuthHeaders()
  );
  return response.data;
};

export const deleteContact = async (id) => {
  const response = await axios.delete(
    `${API_URL}/api/contact/${id}`,
    getAuthHeaders()
  );
  return response.data;
};

export const getServiceRequests = async () => {
  const response = await axios.get(`${API_URL}/api/contact/service-requests`, getAuthHeaders());
  return response.data;
}; 